module.exports = __webpack_public_path__ + "img/1.76a9bdd6.jpg";